var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-basic"}},[_c('header',[_c('BasicHeader',{attrs:{"current-user":_vm.currentUser}})],1),_c('div',{class:{ 'mt129': _vm.isHome },staticStyle:{"minHeight":"calc(100vh - 195px)"}},[_c('router-view',{key:_vm.key})],1),_c('footer',[_c('BasicFooter')],1),_c('a-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }